export default "__VITE_ASSET__pOsYbAKO__"